import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { ROLES } from "common/constants/constants";
import Menu from "common/menu/index";
import { getUserRoleFromStorage } from "common/utils/utilities";
import Loader from "components/common/loader/Loader";
import { checkRole } from "utils/Utils";

import { getBranchProducts } from "services/branchServices";

import "./branchDetails.scss";
import { camalize } from "utils/Utils";
import { usePermission } from "hooks/permission/usePermission";
import { USERS, BILLING } from "common/constants/permissionKeys";
import { useTranslation } from "react-i18next";
import { productMenus } from "utils/Utils";
const Detail = ({ branchData, userProfileData }) => {
  const { t } = useTranslation();
  const { checkPermission } = usePermission();
  const navigate = useNavigate();
  const [branchProducts, setBranchProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const {
    branchName = "",
    branchLocation = "",
    balanceTotal = "",
    branchInformation = "",
  } = branchData?.branch || {};

  const {
    firstName = "",
    lastName = "",
    email = "",
    phoneNumber = "",
  } = branchData?.contactPerson || {};

  const menus = productMenus();
  const {
    branchId = "",
    bankId = "",
    bankGroupId = "",
  } = Object.keys(userProfileData).length !== 0 ? userProfileData : {};

  const branchProductsHandler = async () => {
    let pathIds = {
      branchId,
      bankId,
      bankgroupsId: bankGroupId,
    };
    setIsLoading(true);

    const result = await getBranchProducts(pathIds);

    if (result.success) {
      let newBranchProducts = result.payLoad.filter((product) => {
        return product?.assigned === "Active";
      });

      setIsLoading(false);
      setBranchProducts(newBranchProducts);
    } else {
    }
  };

  useEffect(() => {
    if (Object.keys(userProfileData).length > 0) {
      branchProductsHandler();
    }
  }, [userProfileData]);

  const handleMenuItemClick = (object) => {
    const {
      productId,
      navigateTo,
      translatedValue,
      lable,
      path: redirectionPath,
      ...rest
    } = object;
    const {
      branchId = "",
      bankId = "",
      bankGroupId = "",
    } = Object.keys(userProfileData).length !== 0 ? userProfileData : {};
    const pathIds = { branchId, bankId, bankGroupId, productId };
    const path = {
      gecco: {
        addPayment: navigateTo,
        uploadDocument: `${productId}/${navigateTo}`,
      },
      futurecare: {
        createTeam: navigateTo,
        addPayment: navigateTo,
        uploadDocument: `${productId}/${navigateTo}`,
      },
    };

    navigate(path[camalize(translatedValue)][camalize(redirectionPath)], {
      state: { ...rest, pathIds, translatedValue },
    });
  };

  const checkPermissionForMenu = (key) => {
    return menus[key].some((ele) => ele?.isPermission);
  };
  const isBillingPermission = checkPermission(BILLING);
  const isUserPermission = checkPermission(USERS);
  return (
    <div>
      {isLoading ? (
        <Loader />
      ) : (
        <Row className="branch-details">
          <Col md={4}>
            <p style={{ fontWeight: "bold" }}>{t("balance-total-h1")}</p>
            <h6>{balanceTotal}</h6>
            <p className="mt-5" style={{ fontWeight: "bold" }}>
              {t("general-info")}
            </p>
            <p>{branchInformation}</p>
            <p className="info">{t("name")}</p>
            <p className="infobody">{branchName}</p>
            <p className="info">{t("location")}</p>
            <p className="infobody">{branchLocation}</p>
            <p className="mt-4" style={{ fontWeight: "bold" }}>
              {t("owned-products")}
            </p>
            <p>{t("branch-access")}</p>

            {branchProducts?.map((product) => {
              const {
                productId = "",
                translatedValue = "",
                imageUrl = "",
                ownedSince = "",
                revenueTranslatedValue = "",
              } = Object.keys(product).length !== 0 && product;
              return (
                <>
                  <div className=" mt-4 d-flex">
                    <img
                      src={`/assets/icons${imageUrl}`}
                      width={30}
                      height={30}
                    />
                    <div className="d-flex w-100 justify-content-between align-items-start">
                      <p className="px-2">
                        {translatedValue}
                        <p className="info infobody">{t("owned-since")}</p>
                        <p>
                          {ownedSince &&
                            ownedSince
                              .toLocaleString("en-US")
                              .split("T")[0]
                              .split("-")
                              .reverse()
                              .join(".")}
                        </p>
                        {/* <p className="info infobody">{t("revenue-model")}</p>
                        <p>{t(revenueTranslatedValue)}</p> */}
                      </p>
                      <div
                        className="input-menu-container"
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        {checkRole() === "#EA" &&
                          checkPermissionForMenu(
                            translatedValue.replaceAll(" ", "").toLowerCase()
                          ) ? (
                          <Menu
                            list={menus[
                              translatedValue.replaceAll(" ", "").toLowerCase()
                            ].filter(function (menu) {
                              return menu.isPermission === true;
                            })}
                            handleMenuItemClick={(object) =>
                              handleMenuItemClick({
                                imageUrl,
                                translatedValue,
                                productId,
                                ...object,
                              })
                            }
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <hr></hr>
                </>
              );
            })}
          </Col>
          <Col md={4}>
            <p style={{ fontWeight: "bold" }}>{t("contact-person")}</p>
            <p className="info">{t("name")}</p>
            <p className="infobody">{`${firstName} ${lastName}`}</p>
            <p className="info">{t("email")}</p>
            <p className="infobody">{`${email}`}</p>
            <p className="info">{t("phone-no")}</p>
            <p className="infobody">{phoneNumber}</p>
          </Col>
          {isBillingPermission || isUserPermission ? (
            <Col md={4}>
              <Card className="box">
                <Card.Body>
                  <Card.Text>
                    <p style={{ fontWeight: "bold" }}>{t("shortcuts")}</p>
                    <p>{t("shortcuts-description")}</p>
                  </Card.Text>
                  {isUserPermission ? (
                    <div>
                      <Button
                        className="branch-btn mt-2"
                        variant="btn-error"
                        onClick={() => {
                          navigate("/user-management");
                        }}
                      >
                        {t("user-management")}
                      </Button>
                      <br></br>
                    </div>
                  ) : null}
                  {isBillingPermission ? (
                    <div>
                      <Button
                        className="branch-btn  my-3"
                        variant="btn-error"
                        onClick={() => {
                          getUserRoleFromStorage().roleName ===
                            ROLES.branch_admin
                            ? navigate("/billing")
                            : navigate("/payment");
                        }}
                      >
                        {t("payment")}
                      </Button>
                    </div>
                  ) : null}
                </Card.Body>
              </Card>
            </Col>
          ) : null}
        </Row>
      )}
    </div>
  );
};

export default Detail;
